import { render, staticRenderFns } from "./ant_empty.vue?vue&type=template&id=4dda3546&"
import script from "./ant_empty.vue?vue&type=script&lang=js&"
export * from "./ant_empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports